import Layout from 'components/commons/layouts/Layout'
import styles from './LegalLayout.module.scss'

interface Props {
  children: React.ReactNode
  title: string
}

const LegalLayout: React.FC<Props> = ({ children, title }: Props): JSX.Element => {
  return (
    <Layout>
      <div className={styles.layer}>
        <div className={styles.wrap}>
          <h2 className={styles.title}>{title}</h2>
          {children}
        </div>
      </div>
    </Layout>
  )
}

export default LegalLayout
